import { gql } from 'apollo-angular';

export const UPDATE_TIME_ENTRY_MUTATION = gql`
mutation updateTimeEntry($timeEntryInput: TimeEntryInput) {
  updateTimeEntry(timeEntryInput: $timeEntryInput) {
    id
  }
}
`;

export const CREATE_TIME_ENTRY_MUTATION = gql`
mutation createTimeEntry($timeEntryInput: TimeEntryInput) {
  createTimeEntry(timeEntryInput: $timeEntryInput) {
    id
  }
}
`;

export const DELETE_TIME_ENTRY_MUTATION = gql`
mutation deleteTimeEntry($timeEntryId: UUID) {
  deleteTimeEntry(timeEntryId: $timeEntryId)
}
`;

// export const GET_TIME_ENTRY_CATEGORIES_QUERY = gql`
// query getTimeEntryCategories{
//   getTimeEntryCategories(filter:{}){
//     id
//     name
//   }
// }
// `;

// export interface GetTimeEntryCategoriesResponse {
//   getTimeEntryCategories: TimeEntryCategory[];
//   loading: boolean;
// }
